/* eslint-disable import/no-anonymous-default-export */
import { AxiosError } from "axios"
import useApi from "../../common/hooks/useApi"

export type EstadoJuzgado = ( "NO_JUZGADA" | "DESCARGO_PRESENTADO" | "SENTENCIA_REALIZADA" )

type EstadoDescargo = ( "PRESENTADO" | "ACEPTADO" | "RECHAZADO" )

export interface Descargo {
    FechaPresentado: string
    FechaAceptado: string
    FechaRechazado: string
    Estado: EstadoDescargo
    Motivo: string
    Detalles: string
    File: File
}

export interface Sentencia {
    TipoSentencia: string
    Email?: string,
    NroExpediente: number
    NroResolucion: string
    FechaGenerada: string
    Anio?: number
}


export default () => {
    const module = "Juzgado";
    const api = useApi({ module });

    return {
        async createDescargoById(data : FormData) {
            try {                
                await api.axiosInstance.post(`${module}/Descargos`, data, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });                
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {
        
                return {
                    error
                };
            }
        },        
    };
}